import nbaFranchises from "../data/nbaFranchises.json";
import { MIN_DIRECTORY_QUERY_LENGTH } from "../components/playerSearch/playerSearchCatalog";

export const getActiveNbaFranchises = () => nbaFranchises.active || [];

export function getNbaFranchise(franchiseId) {
  const id = String(franchiseId || "").toUpperCase();
  if (!id) return null;
  return (
    getActiveNbaFranchises().find((franchise) => franchise.id === id) || null
  );
}

function franchiseSearchNames(franchise) {
  return [
    franchise.id,
    franchise.name,
    ...(franchise.aliases || []).map((alias) => alias.name),
  ].filter(Boolean);
}

export function filterNbaFranchises(franchises = [], query = "") {
  const needle = String(query).trim().toLowerCase();
  if (needle.length < MIN_DIRECTORY_QUERY_LENGTH) return [];
  return franchises
    .filter((franchise) =>
      franchiseSearchNames(franchise).some((name) =>
        String(name).toLowerCase().includes(needle)
      )
    )
    .map((franchise) => ({
      id: franchise.id,
      label: franchise.name,
    }));
}

export function railTeamsFromNbaFranchises(franchises = []) {
  return franchises
    .filter((franchise) => franchise.active !== false)
    .map((franchise) => ({
      id: franchise.id,
      name: franchise.name,
      sport: "nba",
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
